export function not(predicate) {
    return (value) => !predicate(value);
}
//# sourceMappingURL=predicate.js.map